interface ChecksStatusStripProps {
    workspaceId: string;
}

// Hidden until forecast workbench ships.
export function ChecksStatusStrip(_props: ChecksStatusStripProps) {
    return null;
}
